import { Injectable } from '@angular/core';
import flagsmith from 'flagsmith';
import { IFeatureFlagProvider } from './feature-flag.provider';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FlagsmithProvider implements IFeatureFlagProvider {
  // Client Side Environment ID
  private readonly environmentID = environment.flagsmithEnvironmentID;

  async init(): Promise<void> {
    try {
      await flagsmith.init({
        environmentID: this.environmentID,
        // Optional: you can pass an identity here if you have one
        // identity: 'user_id', 
      });
      console.log('Flagsmith initialized successfully');
    } catch (error) {
      console.error('Failed to initialize Flagsmith', error);
      // We don't rethrow because the service handles fallbacks
    }
  }

  getValue(key: string): boolean {
    // flagsmith.hasFeature returns true/false. 
    // It evaluates based on the current state of flagsmith.
    return flagsmith.hasFeature(key);
  }
}
